export const kpiBoxCardTypes = {
    fearAndGreed: '1',
    bullBearRatio: '2',
    vix: '3',
    interestRate: '4',
}

export const initMarketAnalysisKpiCardsConfiguration = [
    kpiBoxCardTypes.fearAndGreed,
    kpiBoxCardTypes.vix,
]

export const tabConstants = {
    report: 'report',
    personalized: 'personalized',
    sentiment: 'sentiment',
}